import React from 'react';
import { IconButton as ChakraIconButton, IconButtonProps as ChakraIconButtonProps } from '@chakra-ui/react';

import { useDarkenInteractionStyles } from '../../lib';

interface IButtonProps extends ChakraIconButtonProps {
	backgroundColor?: string;
	hoverDarken?: number; // Percentage to darken color on hover
	activeDarken?: number; // Percentage to darken color when active
}

export const IconButton: React.FunctionComponent<IButtonProps> = ({
	onClick,
	children,
	backgroundColor = 'blue.500',
	hoverDarken = 15,
	activeDarken = 30,
	...props
}) => {
	const { hoverStyle, activeStyle } = useDarkenInteractionStyles(backgroundColor, hoverDarken, activeDarken);
	return (
		<ChakraIconButton
			onClick={onClick}
			backgroundColor={backgroundColor}
			_hover={hoverStyle}
			_active={activeStyle}
			_focus={activeStyle}
			{...props}
		>
			{children}
		</ChakraIconButton>
	);
};
